import { createSelector } from "reselect";
import { getFlyerDetailState } from "../../../store/flyer-detail.store";
import {
  FlyerDetailPageEditType,
  FlyerDetailPageState,
} from "../types/flyer-detail-page-state/flyer-detail-page-state.interface";
import { IFlyerDetailState } from "../../../types/flyer-detail-state/flyer-detail-state.interface";
import Store from "../../../../../../../redux/store";
import * as actions from "./flyer-detail-page.actions";
import { IFlyerDetailPage } from "../../../../../types/flyer-detail-data/flyer-detail-page/flyer-detail-page.interface";
import { Language } from "../../../../../../../types/language.type";
import { FlyerDetailPagePreview } from "../types/flyer-detail-page-preview/flyer-detail-page-preview.interface";
import { Nullable } from "../../../../../../../types/common";

export const getFlyerDetailPageState = createSelector(
  getFlyerDetailState,
  (state: IFlyerDetailState) => state.flyerDetailPageState
);

export const getPagePreview = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.pagePreview || null
);

export const getPageId = createSelector(
  getPagePreview,
  (preview: Nullable<FlyerDetailPagePreview>) => preview?.pageId || null
);

export const getPageTemplate = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.template || null
);

export const getEditPositionId = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.editPagePositionId || null
);

export const getSelectedLanguage = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.selectedLanguage || "en"
);

export const getEditType = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.editingType || "page"
);

export const isLoading = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.isLoading || false
);

export const getError = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.error
);

export function fetchPagePreview(pageId: number | string) {
  Store.dispatch(actions.fetchPagePreview(Number(pageId)));
}

export function resetEditType() {
  Store.dispatch(actions.resetEditType());
}

export function setEditType(editType: FlyerDetailPageEditType) {
  Store.dispatch(actions.setEditType(editType));
}

export function deSelectBlock() {
  Store.dispatch(actions.deSelectPosition());
}

export function updatePage(changes: Partial<IFlyerDetailPage>) {
  Store.dispatch(actions.updatePage(changes));
}

export function selectLanguage(language: Language) {
  Store.dispatch(actions.selectLanguage(language));
}

export function navigateToFlyerPages(flyerId: number) {
  Store.dispatch(actions.navigateToFlyerPages(flyerId));
}

export function createPagePosition(templatePositionId: number) {
  Store.dispatch(actions.createPagePosition(templatePositionId));
}

export function editPagePosition(pagePositionId: number) {
  Store.dispatch(actions.setEditPagePositionId(pagePositionId));
}
